import React from 'react'
import {useCustomFields} from "../../../hooks/useCustomFields";
import {ReactComponent as Ghs01} from '../../../svg/ghs01.svg';
import {ReactComponent as Ghs02} from '../../../svg/ghs02.svg';
import {ReactComponent as Ghs03} from '../../../svg/ghs03.svg';
import {ReactComponent as Ghs04} from '../../../svg/ghs04.svg';
import {ReactComponent as Ghs05} from '../../../svg/ghs05.svg';
import {ReactComponent as Ghs06} from '../../../svg/ghs06.svg';
import {ReactComponent as Ghs07} from '../../../svg/ghs07.svg';
import {ReactComponent as Ghs08} from '../../../svg/ghs08.svg';
import {ReactComponent as Ghs09} from '../../../svg/ghs09.svg';
import {styled} from 'linaria/react'
import {theme} from "../../Theme";

const Container = styled.section`
  padding: 1rem 1rem;

  .pictograms {
    svg {
      width: 6.75rem;
      height: 6.75rem;

      ${theme.below.md} {
        width: 5rem;
        height: 5rem;
      }
    }
  }

  .signal-word {
    font-size: 1.125rem;
    font-family: ${theme.font.family.heading};
    font-weight: ${theme.fontWeights.bold};
    padding: 0.75rem 0 0;
  }

  .danger-description {
    padding: 0.5rem 0 0;
    font-size: 0.875rem;
    line-height: 1.3;
  }

`

const ClpArea = ({product}) => {

  const fields = useCustomFields(product, {
    fields: [
      'signalord',
      'faroangivelse',
      'ghs01',
      'ghs02',
      'ghs03',
      'ghs04',
      'ghs05',
      'ghs06',
      'ghs07',
      'ghs08',
      'ghs09'
    ],
  });
  const clpData = fields.extracted;

  // CHECK IF THERE ARE ANY DANGER INDICATIONS TO BE RENDERED
  let showClpInfo = false;
  for (const key in clpData) {
    if(clpData[key] && clpData[key].value) {
      showClpInfo = true;
    }
  }


  // PICTOGRAMS
  const showPictogram = ghsKey => {
    return clpData[ghsKey] && clpData[ghsKey].boolValue;
  }

  // SIGNAL WORD
  const signalWordTemplate = clpData['signalord'];
  let signalWordString = '';
  if (signalWordTemplate) {
    if (signalWordTemplate.value === '1') {
      signalWordString = 'Varning';
    }
    else if (signalWordTemplate.value === '2') {
      signalWordString = 'Fara';
    }
  }

  return showClpInfo ? (
    <Container>

      <div className='pictograms'>
        {showPictogram('ghs01') && <Ghs01/>}
        {showPictogram('ghs02') && <Ghs02/>}
        {showPictogram('ghs03') && <Ghs03/>}
        {showPictogram('ghs04') && <Ghs04/>}
        {showPictogram('ghs05') && <Ghs05/>}
        {showPictogram('ghs06') && <Ghs06/>}
        {showPictogram('ghs07') && <Ghs07/>}
        {showPictogram('ghs08') && <Ghs08/>}
        {showPictogram('ghs09') && <Ghs09/>}
      </div>

      {signalWordString && <div className='signal-word'>{signalWordString}</div>}

      {clpData['faroangivelse'] &&
      clpData['faroangivelse'].value &&
      <p className='danger-description'>{clpData['faroangivelse'].value}</p>}

    </Container>
  ) : null;
}

export default ClpArea
